import React, { useEffect } from 'react'
import { Grid } from '@mui/material'
import { TrustpilotHeaderFallback } from '@zuto/icons'
import ZutoAnalyticsHelper from '@zuto-internal/zuto-analytics-helper'
import $console from '@zuto/utilities/src/$console'
import TrustBox from './TrustBox'

interface TrustPilotHeaderProps {
  adBlockDetected?: boolean
}

const TrustPilotHeader = ({
  adBlockDetected
} : TrustPilotHeaderProps): JSX.Element => {
  const zutoAnalyticsHelper = new ZutoAnalyticsHelper()

  useEffect(() => {
    if (adBlockDetected) {
      try {
        zutoAnalyticsHelper.sendCustomEvent({
          eventType: 'HeaderTrustPilotDidNotLoad',
          eventCategory: 'adBlockDetected'
        })
      } catch (e) {
        $console.error('zutoAnalyticsHelper.sendCustomEvent error', e)
      }
    }
  }, [adBlockDetected])

  if (adBlockDetected) {
    return (
      <Grid style={{ textAlign: 'center' }}>
          <TrustpilotHeaderFallback data-testid="adBlockDetected" id="tag_header-tp-fallback"/>
      </Grid>
    )
  }

  return (
    <Grid mt={4} mb={4} style={{ textAlign: 'center' }}>
      <TrustBox  />
    </Grid>
  )
}

export default TrustPilotHeader
